module.exports = __webpack_public_path__ + "static/labs-banner-bc19b2d26b2d1e90a5a40de91518bc29.svg";